import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { CareerOneStopTrainingResponse } from 'tuapath-common/generated/schema';


type Results = {
  user: {
    training: CareerOneStopTrainingResponse;
  };
};
type Variables = {
  userId: number;
  offset: number;
  pageSize: number;
  days: number;
  radius: number;
  occupation: string;
  programName: string;
  programLength: string;
  keyword?: string;
  zip?: string;
};

export const useTraining = (options?: QueryHookOptions<Results, Variables>) => {
  const query = gql`
    query getTraining($userId: Int!, $offset: Int!, $pageSize: Int!, $days: Int!, $radius: Int!, $occupation: String!, $programName: String!, $programLength: String!, $keyword: String, $zip: String) {
      user(id: $userId) {
        id
        training(offset: $offset, pageSize: $pageSize, days: $days, radius: $radius, occupation: $occupation, programName: $programName, programLength: $programLength, keyword: $keyword, zip: $zip) {
          totalCount
          training {
            id
            city
            stateAbbr
            schoolUrl
            programName
            schoolName
            programLength {
              Name
              Value
            }
          }
        }
      }
    }
  `;

  return useQuery<Results, Variables>(query, options);
};

export default useTraining;
